import { createKeyedDataAsyncSlice } from '../createKeyedDataAsyncSlice';
import { getClientDocumentsAsync } from '../../API/clientPortal/clientOrderAPI';

export const { slice: getClientOrderDocumentsSlice, asyncAction: getClientOrderDocumentsAction } =
  createKeyedDataAsyncSlice('getClientOrderDocuments', getClientDocumentsAsync, (orderId) => `${orderId}`);
